import { render, staticRenderFns } from "./KOToExternal.vue?vue&type=template&id=5551e08b&"
import script from "./KOToExternal.vue?vue&type=script&lang=js&"
export * from "./KOToExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports